import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.grayLight};
  padding: 1rem;
`;
